import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../api';
import toast from 'react-hot-toast';
import { Zap } from 'lucide-react';
import Button from '../components/Button';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handle = async e => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error('Passwords do not match');
    if (form.password.length < 8) return toast.error('Password must be at least 8 characters');
    setLoading(true);
    try {
      await resetPassword(token, form.password);
      toast.success('Password updated — please sign in');
      navigate('/login');
    } catch (err) {
      toast.error(err?.error || 'Reset failed — the link may have expired');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div style={{ display:'flex', alignItems:'center', gap:11, marginBottom:26 }}>
          <div style={{ width:42, height:42, background:'var(--grad)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 8px 20px var(--accent-glow)' }}>
            <Zap size={20} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:'var(--text)' }}>WP Manager</div>
            <div style={{ fontSize:11, color:'var(--text3)' }}>Set a new password</div>
          </div>
        </div>

        {!token ? (
          <>
            <h2>Invalid link</h2>
            <p>This reset link is missing or malformed. Please request a new one.</p>
            <p style={{ textAlign:'center', fontSize:12, color:'var(--text3)', marginTop:8 }}>
              <Link to="/forgot-password" className="auth-link">Request a new link</Link>
            </p>
          </>
        ) : (
          <>
            <h2>Reset password</h2>
            <p>Enter a new password for your account.</p>
            <form onSubmit={handle}>
              <div className="field">
                <label>New password</label>
                <input type="password" placeholder="Min 8 characters" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} minLength={8} required />
              </div>
              <div className="field">
                <label>Confirm password</label>
                <input type="password" placeholder="Re-enter password" value={form.confirm} onChange={e=>setForm({...form,confirm:e.target.value})} minLength={8} required />
              </div>
              <Button type="submit" className="btn primary" style={{ width:'100%', justifyContent:'center', marginTop:4 }} loading={loading}>
                {loading ? 'Updating...' : 'Update password'}
              </Button>
            </form>
            <p style={{ marginTop:16, textAlign:'center', fontSize:12, color:'var(--text3)' }}>
              <Link to="/login" className="auth-link">Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
